import { StoreState } from 'app/models/types';
import { createSelector } from 'reselect';
import { localeSelector } from './general';
import { userTypeSelector } from './user';

export const loadingSelector = (state: StoreState) => state.ui.loading;
export const paxTooltip = (state: StoreState) => state.ui.loading;

export const paxTooltipVisibleSelector = (state: StoreState) => createSelector(
  localeSelector,
  userTypeSelector,
  (locale, userType) =>
    state.ui.paxTooltipVisible
    && locale === 'tr'
    && (userType === 'customer' || userType === 'logged-in-customer')
    // HACK: remove me!
    // ATM search mask does not know if it's mounted in shop or not
    // as the pax feature is temporary let' not add to complexity
    && window.location.host.match(/shop/)
)(state)